import { DADOS_COMPLEMENTARES_DOCUMENTO, TYPES } from './types'

export const setFormulario = (
  value: DADOS_COMPLEMENTARES_DOCUMENTO['formulario']
) => ({
  type: TYPES.SET_FORMULARIO,
  value
})

type FormularioField = keyof DADOS_COMPLEMENTARES_DOCUMENTO['formulario']
export const setFormularioField = <T extends FormularioField>(
  value: T extends keyof DADOS_COMPLEMENTARES_DOCUMENTO['formulario']
    ? DADOS_COMPLEMENTARES_DOCUMENTO['formulario'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_FORMULARIO_FIELD,
  value,
  field
})

export const cleanFormulario = () => ({
  type: TYPES.CLEAN_FORMULARIO
})

type InvalidFormularioField =
  keyof DADOS_COMPLEMENTARES_DOCUMENTO['invalidFormulario']
export const setInvalidFormularioField = <T extends InvalidFormularioField>(
  value: T extends keyof DADOS_COMPLEMENTARES_DOCUMENTO['invalidFormulario']
    ? DADOS_COMPLEMENTARES_DOCUMENTO['invalidFormulario'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_INVALID_FORMULARIO,
  value,
  field
})

export const cleanInvalidsFormulario = () => ({
  type: TYPES.CLEAN_INVALIDS_FORMULARIO
})

export const salvarCadastroSaga = () => ({
  type: TYPES.SALVAR_CADASTRO_SAGA
})

export const getOrgaosEmissoresSaga = () => ({
  type: TYPES.GET_ORGAOS_EMISSORES_SAGA
})

export const getUfsOrgaosEmissoresSaga = () => ({
  type: TYPES.GET_UFS_ORGAOS_EMISSOR_SAGA
})

type LoadingSelectFields =
  keyof DADOS_COMPLEMENTARES_DOCUMENTO['loadingSelects']
export const setLoadingSelect = <T extends OptionsSelectFields>(
  value: T extends LoadingSelectFields
    ? DADOS_COMPLEMENTARES_DOCUMENTO['loadingSelects'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_LOADING_SELECTS,
  value,
  field
})

type OptionsSelectFields =
  keyof DADOS_COMPLEMENTARES_DOCUMENTO['optionsSelects']
export const setOptionsSelect = <T extends OptionsSelectFields>(
  value: T extends OptionsSelectFields
    ? DADOS_COMPLEMENTARES_DOCUMENTO['optionsSelects'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_OPTIONS_SELECT,
  value,
  field
})

export const getDadosComplementaresDocumentoSaga = () => ({
  type: TYPES.GET_DADOS_COMPLEMENTARES_DOCUMENTO_SAGA
})

export const getCpfSaga = () => ({
  type: TYPES.GET_CPF_SAGA
})

export const setCpf = (value: string) => ({
  type: TYPES.SET_CPF,
  value
})
